import apiHelper from '@/services/helper'

const getAllSeller = async () => {
    try {
        let url = '/admin/sale/get-all'
        // TODO response.data
        return (await apiHelper.getWithFirebaseToken(url)).data
    } catch (error) {
        throw new Error(error)
    }
}

const approveCustomer = async (param) => {
    try {
        let url = '/admin/user/approve'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const financeConfirm = async (param) => {
    try {
        let url = '/admin/user/finance-confirm'
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

const getALlSaleCode = async (param) => {
    try {
        let url = '/admin/sale/get-all-code'
        // TODO response.data
        return (await apiHelper.postWithFirebaseToken(url, param)).data
    } catch (error) {
        throw new Error(error)
    }
}

export default {
    getAllSeller,
    approveCustomer,
    financeConfirm,
    getALlSaleCode
}
